// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalBlackBgTemplate_LRo0F {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.modalBlackContent_l1AQW {
  -webkit-animation: scaleUp_JsbQw 300ms ease-out forwards;
  z-index: 10;
  width: 100vw;
  
  min-height: 100vh;
  max-height: 100vh;

  background-color: var(--f5-background);
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  overflow: hidden;
  @media (width<=768px) {
    height: 100vh !important;
  }
}

.bgModalBlackBgTemplate_v_Iko {
  background-color: var(--_00000020-background);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;

}

.scaleDown_XgYmI {
  animation: scaleDown_XgYmI 300ms ease-in forwards;
  -webkit-animation: scaleDown_XgYmI 300ms ease-in forwards;
}

@keyframes scaleUp_JsbQw {
  from {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
  }
  to {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
  }
}

@keyframes scaleDown_XgYmI {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
  }
}

.fadeOut_Ya8W4 {
  opacity: 0;
}

.cssToPanelAutomate_uhtQ5 {
  -webkit-animation: scaleUp_JsbQw 300ms ease-out forwards;
  z-index: 2;
  background-color: var(--f5-background);
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ModalBlackBgTemplate/ModalBlackBgTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,wDAAkD;EAClD,WAAW;EACX,YAAY;;EAEZ,iBAAiB;EACjB,iBAAiB;;EAEjB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;;AAEZ;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wDAAkD;EAClD,UAAU;EACV,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".ModalBlackBgTemplate {\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n}\n\n.modalBlackContent {\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  z-index: 10;\n  width: 100vw;\n  \n  min-height: 100vh;\n  max-height: 100vh;\n\n  background-color: var(--f5-background);\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  overflow: hidden;\n  @media (width<=768px) {\n    height: 100vh !important;\n  }\n}\n\n.bgModalBlackBgTemplate {\n  background-color: var(--_00000020-background);\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1;\n\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.cssToPanelAutomate {\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  z-index: 2;\n  background-color: var(--f5-background);\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ModalBlackBgTemplate": `ModalBlackBgTemplate_LRo0F`,
	"modalBlackContent": `modalBlackContent_l1AQW`,
	"scaleUp": `scaleUp_JsbQw`,
	"bgModalBlackBgTemplate": `bgModalBlackBgTemplate_v_Iko`,
	"scaleDown": `scaleDown_XgYmI`,
	"fadeOut": `fadeOut_Ya8W4`,
	"cssToPanelAutomate": `cssToPanelAutomate_uhtQ5`
};
export default ___CSS_LOADER_EXPORT___;
